module.exports = __webpack_public_path__ + "static/media/pickup_inactive.fce98353.svg";